
import { Select } from './Select';


export const Module2 = (props) => { 
  
  return ( 
    <>
    <div className="fetcher">
      <div className="header">
      <div className="headline">
        <i className="fas fa-cog"></i>Module 2
        </div>
        <div className="right">
        <Select 
          placeholder="Select..." 
          options={['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5']}
        />
        <i className="fa-solid fa-clock"></i>00:00:00
        </div>
      </div>
      <div className="body mod2">
      <h1>Lorem ipsum <span className="orange">color</span></h1>
      <div className="poster" style={{width:'300px',height:'200px'}}>
      <div className="poster_header">Test</div>
      <div className="poster_body">
        <Select 
          placeholder="Select..." 
          options={['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6']}
          />
        <br />
        <Select 
          placeholder="Select..." 
          options={['Item 1', 'Item 2', 'Item 3', 'Item 4']} 
        />
      </div>
      
      </div>
      </div>
      <div className="footer">
        Status<div className="right">All processes running</div>
      </div>
    </div>
    </>
  ); 

} 

